// extracted by mini-css-extract-plugin
module.exports = {"boxContain":"styles_boxContain__3FwPb","colorContainer":"styles_colorContainer__3YRrY"};